// Module
var code = "<inv-tooltip ng-if=\"$ctrl.tooltipContext.items.length > 0\" context=\"$ctrl.tooltipContext\" template=\"$ctrl.tooltipTemplate\">\n</inv-tooltip>\n";
// Exports
module.exports = code;